import SEOHead from '@/components/base/SEOHead';
import StructuredData from '@/components/base/StructuredData';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import QuickFacts from './components/QuickFacts';
import BiographySection from './components/BiographySection';
import CareerTimeline from './components/CareerTimeline';
import FeaturedWorks from './components/FeaturedWorks';
import LatestNews from './components/LatestNews';
import { siteConfig } from '@/mocks/site';

export default function Home() {
  const homepageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteConfig.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
  };

  return (
    <>
      <SEOHead
        title="冲田杏梨 - 完整资料与作品全收录 | 冲田杏梨粉丝资讯站"
        description={siteConfig.description}
        keywords={siteConfig.keywords}
        canonicalUrl={siteConfig.url}
        ogImage={siteConfig.ogImage}
      />
      <StructuredData data={homepageSchema} />
      <StructuredData data={orgSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <article>
            <HeroBanner />
            <QuickFacts />
            <BiographySection />
            <CareerTimeline />
            <FeaturedWorks />
            <LatestNews />
          </article>

          <section className="py-14 md:py-18 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-[family-name:var(--font-heading)] mb-3">
                粉丝常见问题
              </h2>
              <div className="mt-8 max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
                {[
                  {
                    q: '冲田杏梨的出生地是哪里？',
                    a: '冲田杏梨出生于英国伯明翰，父亲是日本人，母亲拥有英国血统，她拥有英日双重文化背景。',
                  },
                  {
                    q: '冲田杏梨是什么时候出道的？',
                    a: '冲田杏梨于2011年正式出道，凭借出色的外形条件和国际背景迅速获得关注。',
                  },
                  {
                    q: '冲田杏梨会说几种语言？',
                    a: '冲田杏梨精通英语和日语，在英国度过的童年使她掌握了流利的英语能力。',
                  },
                  {
                    q: '冲田杏梨有哪些爱好？',
                    a: '冲田杏梨热爱钢琴演奏、书法、英语会话、旅行和美食，是一位多才多艺的艺人。',
                  },
                ].map((faq, i) => (
                  <details key={i} className="group p-4 rounded-lg bg-background-100 border border-background-200/70 cursor-pointer">
                    <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between gap-2">
                      {faq.q}
                      <i className="ri-add-line group-open:hidden text-foreground-400 text-sm"></i>
                      <i className="ri-subtract-line hidden group-open:block text-primary-500 text-sm"></i>
                    </summary>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}